var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 1H16.75C17.3467 1 17.919 1.22827 18.341 1.6346C18.7629 2.04093 19 2.59203 19 3.16667V12.9167C19 13.204 18.8815 13.4795 18.6705 13.6827C18.4595 13.8859 18.1734 14 17.875 14H15.625C15.3266 14 15.0405 13.8859 14.8295 13.6827C14.6185 13.4795 14.5 13.204 14.5 12.9167V10.75C14.5 9.60073 14.0259 8.49853 13.182 7.68587C12.3381 6.87321 11.1935 6.41667 10 6.41667C8.80653 6.41667 7.66193 6.87321 6.81802 7.68587C5.97411 8.49853 5.5 9.60073 5.5 10.75V12.9167C5.5 13.204 5.38147 13.4795 5.17049 13.6827C4.95952 13.8859 4.67337 14 4.375 14H2.125C1.82663 14 1.54048 13.8859 1.32951 13.6827C1.11853 13.4795 1 13.204 1 12.9167V3.16667C1 2.59203 1.23705 2.04093 1.65901 1.6346C2.08097 1.22827 2.65326 1 3.25 1",
    fill: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.d3e59c83d3f314e8b66450814508a34c.svg";
export { ForwardRef as ReactComponent };